import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import * as UserRoles from "../../constants/roles";

export const LiveFeedbackTitle = ({ userRole }) => {
  const getRoleTitle = () =>
    ({
      [UserRoles.TEACHER]: "live_feedback_modal.teacher_title",
      [UserRoles.STUDENT]: "live_feedback_modal.student_title",
    }[userRole]);

  return (
    <GridItem gridColumn="1 / span 8" gridRow="1" marginTop={5}>
      <Text size="medium" fontWeight="medium" as="h1" textAlign="left">
        <FormattedMessage id={getRoleTitle()} />
      </Text>
    </GridItem>
  );
};

LiveFeedbackTitle.propTypes = {
  userRole: PropTypes.oneOf([UserRoles.TEACHER, UserRoles.STUDENT]).isRequired,
};

export default LiveFeedbackTitle;
